import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary.component';
import { UiProvider, useUi } from './components/Toast/Toast.context';
import { installUiGlobals } from './helpers/ui';
import './translation/i18n'

const UiInstaller: React.FC = () => {
  const uiApi = useUi();
  React.useEffect(() => {
    installUiGlobals(uiApi);
  }, [uiApi]);
  return null;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <UserProvider>
          <UiProvider>
            <UiInstaller />
            <App />
          </UiProvider>
        </UserProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/* if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
} */

/* function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
} */


// const vapidPublicKey = "BPtMPh59wNDqiC59GqrdGYX4occjNcOBGwYBGj_0_fUxMoxsRTD8lU4XOpys4cZGQ0VfcFp5LFvRprQIvd03RuY"; // Replace with your actual public key
// const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

if ('serviceWorker' in navigator && 'PushManager' in window) {
  navigator.serviceWorker.register('/service-worker.js').then(registration => {
    // console.log('Service Worker registered:', registration);

    // return registration.pushManager.subscribe({
    //   userVisibleOnly: true,
    //   applicationServerKey: convertedVapidKey,
    // });
  }).then(subscription => {
    // console.log('Push subscription:', subscription);

    // Send subscription object to the backend
    // fetch('/api/subscribe', {
    //   method: 'POST',
    //   body: JSON.stringify(subscription),
    //   headers: { 'Content-Type': 'application/json' },
    // });
  }).catch(err => {
    console.error('Error during service worker registration or push subscription:', err);
  });
}
